import httpService from '@/services/httpService.js';

const $http = httpService;
const requestTimeout = 30 * 1000;

class SessionService {
    constructor(){
        this.user = null;
        // this.permissions = [];
        this.isAuthenticated = false;
        this.instance = null
    }

    async initSession(instance){
        this.instance = instance;
        this.isAuthenticated = false;

        try {
            const res = await $http.get(`/user`, {timeout: requestTimeout, skipPendingList: true, forceUpdate: true})
            const userData = res?.data;
            if (typeof userData === 'string') return Promise.reject();

            this.user = userData;

            window['countryIsoCode'] = userData.country_iso_code;
            instance.provide('$user', this.user);
            this.isAuthenticated = true;

            return Promise.resolve(this.user);
        } catch (error){
            if(error === undefined){
                return Promise.reject({ data: { errors: [{ code: 'Failed to get user data' }] } })
            }
            if(!navigator.onLine){
               return Promise.reject({ data: { errors: [{ code: 'You are offline. Please make sure to check network cables, modem, and router or reconnecting to Wi-Fi and try again' }] } })
            }

            return Promise.reject(error);
        }
    }

    globalError(error) {
        this.instance.config.globalProperties.$initGlobalErrors(error, true);
    }
}

export default new SessionService();